import React, { useState } from 'react';
import {
  Sidebar,
  FilterCard,
  CardHeader,
  CardBody,
  SidebarItem,
  SidebarBar,
  SidebarItemLabel,
  SidebarBadge,
  SidebarCaret,
} from './CoursTicketDetailStyled';

// 좌측 사이드바 — 상태·카테고리 필터 (시안 3c "그룹 카드 분리형").
//   1) 상태(tab):       전체 / 사용 중 / 사용예정 / 만료됨   (별도 카드, 앞에 세로 컬러 바)
//   2) 카테고리(category): 전체(헤더 요약) / 회원권·일반상품(부모) + 하위
// 선택 로직·데이터·counts는 기존 그대로, 렌더링만 3c로 교체.

// 상태별 세로 바 색
const STATUS_BAR = {
  all: '#00919F',
  active: '#12A5B0',
  upcoming: '#3564D6',
  expired: '#C4CAD0',
};

const CategorySidebar = ({ tab, onTabSelect, category, onCategorySelect, counts }) => {
  // 부모(회원권/일반상품) 접힘 상태 — 기본 펼침.
  const [collapsed, setCollapsed] = useState({ tickets: false, products: false });
  const toggleCollapse = key => setCollapsed(prev => ({ ...prev, [key]: !prev[key] }));

  // 상태 행 — 앞에 상태 색 세로 바, 선택 시 청록 tint. 0건은 흐리게.
  const statusItem = (key, label, count) => {
    const isActive = tab === key;
    return (
      <SidebarItem isActive={isActive} dimmed={!isActive && count === 0} onClick={() => onTabSelect(key)}>
        <SidebarItemLabel isActive={isActive}>
          <SidebarBar color={STATUS_BAR[key]} />
          {label}
        </SidebarItemLabel>
        <SidebarBadge isActive={isActive}>{count}</SidebarBadge>
      </SidebarItem>
    );
  };

  // 카테고리 최상위(전체) 행 — 세로 바/캐럿 없이 라벨 + 카운트.
  const topCategoryItem = (key, label, count) => {
    const isActive = category === key;
    return (
      <SidebarItem isActive={isActive} dimmed={!isActive && count === 0} onClick={() => onCategorySelect(key)}>
        <SidebarItemLabel isActive={isActive}>{label}</SidebarItemLabel>
        <SidebarBadge isActive={isActive}>{count}</SidebarBadge>
      </SidebarItem>
    );
  };

  // 카테고리 하위(leaf) 행 — 들여쓰기. 선택 시 청록 tint. 0건은 흐리게.
  const leafItem = (key, label, count) => {
    const isActive = category === key;
    return (
      <SidebarItem isActive={isActive} depth={1} dimmed={!isActive && count === 0} onClick={() => onCategorySelect(key)}>
        <SidebarItemLabel isActive={isActive} depth={1}>
          {label}
        </SidebarItemLabel>
        <SidebarBadge isActive={isActive} depth={1}>
          {count}
        </SidebarBadge>
      </SidebarItem>
    );
  };

  // 카테고리 부모(그룹) 행 — 캐럿 클릭은 접기/펼치기, 행 클릭은 필터 적용. 그룹 0건이면 흐리게.
  const parentItem = (key, label, count, collapseKey) => {
    const isActive = category === key;
    return (
      <SidebarItem isActive={isActive} dimmed={!isActive && count === 0} onClick={() => onCategorySelect(key)}>
        <SidebarItemLabel isActive={isActive} isParent>
          <SidebarCaret
            onClick={e => {
              e.stopPropagation();
              toggleCollapse(collapseKey);
            }}>
            {collapsed[collapseKey] ? '▸' : '▾'}
          </SidebarCaret>
          {label}
        </SidebarItemLabel>
        <SidebarBadge isActive={isActive}>{count}</SidebarBadge>
      </SidebarItem>
    );
  };

  return (
    <Sidebar>
      {/* 상태 카드 */}
      <FilterCard>
        <CardHeader>상태</CardHeader>
        <CardBody>
          {statusItem('all', '전체', counts.statusAll)}
          {statusItem('active', '사용 중', counts.active)}
          {statusItem('upcoming', '사용예정', counts.upcoming)}
          {statusItem('expired', '만료됨', counts.expired)}
        </CardBody>
      </FilterCard>

      {/* 카테고리 카드 — 첫 행이 "전체" 선택 */}
      <FilterCard>
        <CardHeader>카테고리</CardHeader>
        <CardBody>
          {topCategoryItem('all', '전체', counts.total)}
          {parentItem('tickets', '회원권', counts.tickets, 'tickets')}
          {!collapsed.tickets && (
            <>
              {leafItem('pass', '이용권', counts.pass)}
              {leafItem('trial', '일일권', counts.trial)}
              {leafItem('ticket', '수강권', counts.ticket)}
            </>
          )}
          {parentItem('products', '일반상품', counts.products, 'products')}
          {!collapsed.products && (
            <>
              {leafItem('locker', '라커', counts.locker)}
              {leafItem('product', '상품', counts.product)}
            </>
          )}
        </CardBody>
      </FilterCard>
    </Sidebar>
  );
};

export default CategorySidebar;
